import { render, staticRenderFns } from "./edit-insurance.vue?vue&type=template&id=65e11f4b&"
import script from "./edit-insurance.vue?vue&type=script&lang=js&"
export * from "./edit-insurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports